import { useCallback, useEffect, useState } from 'react';
import consultationsApi from 'api/requests/consultations';

/**
 * Estado da consultoria no painel: a consulta marcada (se houver), se o
 * produtor pode marcar outra e os assuntos. Falhar aqui não derruba a página
 * da análise: o banner só perde o estado e a tela de agendamento tenta de novo.
 */
export default function useConsulting() {
    const [state, setState] = useState({ loading: true, failed: false, eligibility: null, booking: null, topics: [] });

    const reload = useCallback(async () => {
        try {
            const { data } = await consultationsApi.status();
            setState({ loading: false, failed: false, eligibility: data.eligibility, booking: data.booking, topics: data.topics || [] });
        } catch (error) {
            setState(current => ({ ...current, loading: false, failed: true }));
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    return { ...state, reload };
}
